module.exports = __webpack_public_path__ + "img/reproduction.9815c389.png";